// extracted by mini-css-extract-plugin
export var content = "_sp-1";
export var wrapper = "_sp-0";